module.exports = __webpack_public_path__ + "img/uploadpic.9a4e3ae2.jpg";